import Main from '@/views/administracion/configuracion/catalogos/expedientes/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/expedientes/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const expedientes = [
  {
    path: 'expedientes',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoExpedientes',
        path: '/',
        meta: {
          title: 'Expedientes',
          auth,
          scopes,
        },
        component: Default,
        children: [],
      },
    ],
  },
];

export default expedientes;
